import { createSignal } from "solid-js";
import type { StudentClass } from "./student";

export function StudentJoinPage(props: {
  canCancel: boolean;
  onCancel: () => void;
  onJoin: (joinCode: string) => Promise<StudentClass>;
}) {
  const [joinCode, setJoinCode] = createSignal("");
  const [busy, setBusy] = createSignal(false);

  const submit = async (event: SubmitEvent) => {
    event.preventDefault();
    if (busy()) return;
    setBusy(true);
    try { await props.onJoin(joinCode()); }
    finally { setBusy(false); }
  };

  return (
    <div style={{ "max-width": "480px", margin: "0 auto" }}>
      <div style={{ "text-align": "center", "margin-bottom": "32px" }}>
        <div style={{ "font-size": "4rem", "margin-bottom": "12px" }} aria-hidden="true">🎒</div>
        <h1>Klasse beitreten</h1>
        <p>Gib den Code ein, den dein Lehrer dir gegeben hat</p>
      </div>

      <form class="card" onSubmit={submit}>
        <div class="form-group">
          <label class="form-label" for="join-code">Klassen-Code</label>
          <input
            id="join-code"
            class="form-input"
            value={joinCode()}
            onInput={(event) => setJoinCode(event.currentTarget.value.toUpperCase())}
            placeholder="z.B. ABCD1234"
            maxlength={8}
            autocomplete="off"
            autofocus
            style={{ "text-transform": "uppercase", "font-size": "1.5rem", "text-align": "center", "letter-spacing": "6px" }}
          />
        </div>
        <button class="btn btn-primary btn-full btn-lg" type="submit" disabled={busy()}>
          {busy() ? "Wird beigetreten…" : "Beitreten →"}
        </button>
        {props.canCancel ? <button class="btn btn-secondary btn-full" type="button" style={{ "margin-top": "8px" }} onClick={props.onCancel}>Abbrechen</button> : null}
      </form>
    </div>
  );
}
